import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'

export interface CurrentWeekNetworkFixedCdSnapshot {
  snapshot_date: string
  week_id: number
  period_id: number
  week_number_in_period: number
  week_start: string
  week_end: string
  days_remaining: number
  open_studios_count: number
  uk_weekly_plan_rub: number
  listok_fact_rub: number
  remaining_to_plan_rub: number
  fixed_cd_rub: number
  calculated_at: string
}

export async function getCurrentWeekNetworkFixedCd(
  periodId: number | null,
  weekNumber: number | null
): Promise<CurrentWeekNetworkFixedCdSnapshot | null> {
  if (periodId == null || weekNumber == null) {
    return null
  }

  const supabase = getSupabase()
  const { data, error } = await withAuthRecovery(() =>
    (supabase as any).rpc('get_current_week_network_fixed_cd', {
      p_period_id: periodId,
      p_week_number: weekNumber,
    })
  ) as {
    data: CurrentWeekNetworkFixedCdSnapshot[] | null
    error: { message?: string } | null
  }

  if (error) {
    throw new Error(error.message || 'Не удалось загрузить цифру дня сети')
  }

  return data?.[0] ?? null
}
